import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { LayoutDashboard, Users, FileText, CreditCard, Coins, Settings, ShieldAlert, KeyRound, ClipboardList, Radio } from "lucide-react";

export default function AdminLayout() {
  const links = [
    { to: "/admin", icon: <LayoutDashboard className="w-4 h-4" />, label: "Dashboard", end: true },
    { to: "/admin/users", icon: <Users className="w-4 h-4" />, label: "Users" },
    { to: "/admin/posts", icon: <FileText className="w-4 h-4" />, label: "Content" },
    { to: "/admin/discord-sync", icon: <Radio className="w-4 h-4" />, label: "Discord Sync" },
    { to: "/admin/payments", icon: <CreditCard className="w-4 h-4" />, label: "Payments" },
    { to: "/admin/contributions", icon: <Coins className="w-4 h-4" />, label: "Contributions" },
    { to: "/admin/manual-verify", icon: <KeyRound className="w-4 h-4" />, label: "Manual Verify" },
    { to: "/admin/audit", icon: <ClipboardList className="w-4 h-4" />, label: "Audit Log" },
    { to: "/admin/settings", icon: <Settings className="w-4 h-4" />, label: "Settings" },
  ];
  return (
    <PageShell>
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex items-center gap-3 mb-6">
          <ShieldAlert className="w-5 h-5 text-amber-400" />
          <div>
            <div className="font-mystic text-rose-400 text-sm">Hidden Sanctum</div>
            <h1 className="font-display text-3xl font-black text-white">Admin Control Room</h1>
          </div>
        </div>
        <div className="grid lg:grid-cols-12 gap-6">
          <aside className="lg:col-span-3">
            <div className="glass rounded-xl p-3 sticky top-24">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  data-testid={`admin-nav-${l.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2.5 rounded-md text-sm transition mb-1 ${
                      isActive ? "bg-rose-600/20 text-white border border-rose-500/40" : "text-zinc-300 hover:bg-white/5"
                    }`
                  }
                >
                  {l.icon}{l.label}
                </NavLink>
              ))}
            </div>
          </aside>
          <div className="lg:col-span-9">
            <Outlet />
          </div>
        </div>
      </div>
    </PageShell>
  );
}